import { render, staticRenderFns } from "./exhibitions.vue?vue&type=template&id=2243c1e2&scoped=true&"
import script from "./exhibitions.vue?vue&type=script&lang=js&"
export * from "./exhibitions.vue?vue&type=script&lang=js&"
import style0 from "./exhibitions.vue?vue&type=style&index=0&id=2243c1e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2243c1e2",
  null
  
)

export default component.exports